import React from 'react';
import Terminal from './Terminal';
import '../Style/components.css';

export default function Menu(props) {
  return (
    <React.Fragment>
      <Terminal
        terminal={props.terminal}
        fire_command={props.fire_command}
        show={props.menu.terminal}
      />
      <div
        style={props.menu.show ? { display: 'block' } : { display: 'none' }}
        className="menu"
      >
        <div className="close" onClick={() => props.toggle()}>
          <i className="fi-rr-cross"></i>
        </div>
        <h3 className="head_text">MENU</h3>
        <div className="folder_body">
          <div
            onDoubleClick={() => props.toggle_terminal()}
            className="root_icons"
          >
            <i className="fi-rr-browser"></i>
            <p className="folder_name">Terminal</p>
          </div>
          <div
            onDoubleClick={() =>
              window.open(
                'https://yashdatir.github.io/My-Games/javascript/tennis/index.html'
              )
            }
            className="root_icons"
          >
            <i className="fi-rr-ping-pong"></i>
            <p className="folder_name">Game</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
